import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function CompleteProfileModal() {
  const { user, setUser } = useAuth();
  const [username, setUsername] = useState(user?.username || "");
  const [displayName, setDisplayName] = useState(user?.display_name || "");
  const [bio, setBio] = useState("");
  const [busy, setBusy] = useState(false);
  const open = !!(user && user.needs_profile);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/complete-profile", {
        username, display_name: displayName, bio,
      });
      setUser(data.user);
      toast.success("Profile set up!");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open}>
      <DialogContent className="card-brutal border-2 border-ink sm:max-w-md" data-testid="complete-profile-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold">Pick your @username</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 pt-2">
          <div>
            <label className="text-xs font-bold uppercase">Username</label>
            <div className="flex items-center border-2 border-ink h-11 mt-1">
              <span className="px-3 text-muted-foreground font-mono">@</span>
              <input data-testid="username-input" value={username}
                onChange={(e) => setUsername(e.target.value.toLowerCase())}
                className="flex-1 h-full outline-none pr-3 font-mono" placeholder="yourname" />
            </div>
          </div>
          <div>
            <label className="text-xs font-bold uppercase">Display name</label>
            <Input data-testid="displayname-input" value={displayName}
              onChange={(e) => setDisplayName(e.target.value)} className="border-2 border-ink mt-1" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase">Bio (optional)</label>
            <Textarea data-testid="bio-input" value={bio} onChange={(e) => setBio(e.target.value)}
              className="border-2 border-ink mt-1" rows={2} />
          </div>
          <Button data-testid="save-profile-btn" disabled={busy || username.length < 3} onClick={save}
            className="w-full border-2 border-ink bg-brand text-white font-bold btn-press shadow-brutal-sm h-12">
            Start my track record
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
